import { Box } from '@ethings/ui-toolkit';
import { FC, ReactNode, RefObject, useEffect, useRef } from 'react';

interface VisibleTimelineMarkerProps {
  children: ReactNode;
  itemId: string;
  onVisibleChange?: (itemId: string, visible: boolean) => void;
  rootRef?: RefObject<HTMLElement | null>;
}

export const VisibleTimelineMarker: FC<VisibleTimelineMarkerProps> = ({ children, itemId, onVisibleChange, rootRef }) => {
  const markerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const markerElement = markerRef.current;
    if (!markerElement || !onVisibleChange) return;

    if (typeof IntersectionObserver === 'undefined') {
      onVisibleChange(itemId, true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => onVisibleChange(itemId, Boolean(entry?.isIntersecting)),
      {
        root: rootRef?.current ?? null,
        threshold: 0.01,
      },
    );

    observer.observe(markerElement);
    return () => {
      observer.disconnect();
    };
  }, [itemId, onVisibleChange, rootRef]);

  return (
    <Box ref={markerRef}>
      {children}
    </Box>
  );
};
